import axios from 'axios';
import MockAdapter from 'axios-mock-adapter';

const apiUrl = process.env.VUE_APP_API_URL;

export default {
  /**
   * load mocks and monitor api calls for 4012/403s
   *
   * @param {object} applicationOptions
   */
  activate(applicationOptions = {}) {
    // create a list of api calls that we need to mock and the responses we want
    const environment = process.env.NODE_ENV;
    if (environment === 'testing') {
      const v1 = `${apiUrl}/v1`;
      const mock = new MockAdapter(axios);
      mock.onDelete(`${v1}/sources/3021`).reply(200, { });
      mock.onPost(`${v1}/notifications/unread_edits/999`).reply(200, {});
      mock.onGet(`${v1}/notifications/unread_edits/999`).reply(200, {
        unread_notifications: 0,
      });

      // Comments
      const replyComment = {
        comment: {
          id: 208,
          commentable_id: 1508,
          commentable_type: 'Document',
          content: 'test',
          parent_id: null,
          user_id: 80,
          created_at: '2018-02-26T21: 11:14.187508',
          updated_at: '2018-02-26T21: 11:14.187508',
          replies: [],
          user: {
            id: 80,
            email: 'droti@watchtowerbenefits.com',
            first_name: 'Domenic',
            last_name: 'Roti',
            carrier: {
              id: 9,
              name: 'Guardian',
              logo_url: 'https: //s3-us-west-2.amazonaws.com/watchtower-public/carrier_logos/guardian.jpg',
            },
            broker: {},
          },
        },
      };
      const carrierComments = {
        comments: [
          {
            id: 62,
            commentable_id: 1508,
            commentable_type: 'Document',
            content: 'test',
            parent_id: null,
            user_id: 80,
            created_at: '2018-02-19T17: 29:38.741478',
            updated_at: '2018-02-19T17: 29:38.741478',
            replies: [
              {
                id: 67,
                commentable_id: 1508,
                commentable_type: 'Document',
                content: 'reply',
                parent_id: '62',
                user_id: 80,
                created_at: '2018-02-19T22:00:47.00357',
                updated_at: '2018-02-19T22:00:47.00357',
                user: {
                  id: 80,
                  email: 'droti@watchtowerbenefits.com',
                  first_name: 'Domenic',
                  last_name: 'Roti',
                  carrier: {
                    id: 9,
                    name: 'Guardian',
                    logo_url: 'https: //s3-us-west-2.amazonaws.com/watchtower-public/carrier_logos/guardian.jpg',
                  },
                  broker: {},
                },
              },
              {
                id: 68,
                commentable_id: 1508,
                commentable_type: 'Document',
                content: 'reply 2',
                parent_id: '62',
                user_id: 80,
                created_at: '2018-02-19T22:25:16.885177',
                updated_at: '2018-02-19T22:25:16.885177',
                user: {
                  id: 80,
                  email: 'droti@watchtowerbenefits.com',
                  first_name: 'Domenic',
                  last_name: 'Roti',
                  carrier: {
                    id: 9,
                    name: 'Guardian',
                    logo_url: 'https: //s3-us-west-2.amazonaws.com/watchtower-public/carrier_logos/guardian.jpg',
                  },
                  broker: {},
                },
              },
              {
                id: 69,
                commentable_id: 1508,
                commentable_type: 'Document',
                content: 'reply 3',
                parent_id: '62',
                user_id: 80,
                created_at: '2018-02-19T22:29:54.553554',
                updated_at: '2018-02-19T22:29:54.553554',
                user: {
                  id: 80,
                  email: 'droti@watchtowerbenefits.com',
                  first_name: 'Domenic',
                  last_name: 'Roti',
                  carrier: {
                    id: 9,
                    name: 'Guardian',
                    logo_url: 'https: //s3-us-west-2.amazonaws.com/watchtower-public/carrier_logos/guardian.jpg',
                  },
                  broker: {},
                },
              },
              {
                id: 70,
                commentable_id: 1508,
                commentable_type: 'Document',
                content: 'reply 4',
                parent_id: '62',
                user_id: 80,
                created_at: '2018-02-19T22:31:33.176935',
                updated_at: '2018-02-19T22:31:33.176935',
                user: {
                  id: 80,
                  email: 'droti@watchtowerbenefits.com',
                  first_name: 'Domenic',
                  last_name: 'Roti',
                  carrier: {
                    id: 9,
                    name: 'Guardian',
                    logo_url: 'https: //s3-us-west-2.amazonaws.com/watchtower-public/carrier_logos/guardian.jpg',
                  },
                  broker: {},
                },
              },
              {
                id: 71,
                commentable_id: 1508,
                commentable_type: 'Document',
                content: 'new reply',
                parent_id: '62',
                user_id: 80,
                created_at: '2018-02-19T23:00:46.547529',
                updated_at: '2018-02-19T23:00:46.547529',
                user: {
                  id: 80,
                  email: 'droti@watchtowerbenefits.com',
                  first_name: 'Domenic',
                  last_name: 'Roti',
                  carrier: {
                    id: 9,
                    name: 'Guardian',
                    logo_url: 'https: //s3-us-west-2.amazonaws.com/watchtower-public/carrier_logos/guardian.jpg',
                  },
                  broker: {},
                },
              },
              {
                id: 72,
                commentable_id: 1508,
                commentable_type: 'Document',
                content: 'test reply',
                parent_id: '62',
                user_id: 80,
                created_at: '2018-02-19T23:01:50.28123',
                updated_at: '2018-02-19T23:01:50.28123',
                user: {
                  id: 80,
                  email: 'droti@watchtowerbenefits.com',
                  first_name: 'Domenic',
                  last_name: 'Roti',
                  carrier: {
                    id: 9,
                    name: 'Guardian',
                    logo_url: 'https: //s3-us-west-2.amazonaws.com/watchtower-public/carrier_logos/guardian.jpg',
                  },
                  broker: {},
                },
              },
            ],
            user: {
              id: 80,
              email: 'droti@watchtowerbenefits.com',
              first_name: 'Domenic',
              last_name: 'Roti',
              carrier: {
                id: 9,
                name: 'Guardian',
                logo_url: 'https: //s3-us-west-2.amazonaws.com/watchtower-public/carrier_logos/guardian.jpg',
              },
              broker: {
              },
            },
          },
        ],
      };
      const brokerComments = {
        comments: [
          {
            id: 119,
            commentable_id: 2749,
            commentable_type: 'Document',
            content: 'Comment to broker',
            parent_id: null,
            user_id: 107,
            created_at: '2018-03-26T21: 04: 37.493686',
            updated_at: '2018-03-26T21: 04: 37.493686',
            replies: [
              {
                id: 120,
                commentable_id: 2749,
                commentable_type: 'Document',
                content: 'Reply from broker',
                parent_id: '119',
                user_id: 150,
                created_at: '2018-03-26T21: 10: 27.405564',
                updated_at: '2018-03-26T21: 10: 27.405564',
                user: {
                  id: 150,
                  email: 'broker@watchtowerbenefits.com',
                  first_name: 'Watch',
                  last_name: 'Tower',
                  carrier: {},
                  broker: {
                    id: 6,
                    name: 'Watchtower Demo Broker',
                    logo_url: 'https: //s3-us-west-2.amazonaws.com/watchtower-public/broker_logos/watchtower.png',
                  },
                },
                is_new: false,
              },
              {
                id: 121,
                commentable_id: 2749,
                commentable_type: 'Document',
                content: 'Reply from carrier',
                parent_id: '119',
                user_id: 107,
                created_at: '2018-03-26T21: 10: 46.942491',
                updated_at: '2018-03-26T21: 10: 46.942491',
                user: {
                  id: 107,
                  email: 'guardian@watchtowerbenefits.com',
                  first_name: 'Guardian ',
                  last_name: 'User',
                  carrier: {
                    id: 9,
                    name: 'Guardian',
                    logo_url: 'https: //s3-us-west-2.amazonaws.com/watchtower-public/carrier_logos/guardian.jpg',
                  },
                  broker: {},
                },
                is_new: false,
              },
              {
                id: 122,
                commentable_id: 2749,
                commentable_type: 'Document',
                content: 'reply from broker',
                parent_id: '119',
                user_id: 150,
                created_at: '2018-03-26T21: 11: 33.467593',
                updated_at: '2018-03-26T21: 11: 33.467593',
                user: {
                  id: 150,
                  email: 'broker@watchtowerbenefits.com',
                  first_name: 'Watch',
                  last_name: 'Tower',
                  carrier: {},
                  broker: {
                    id: 6,
                    name: 'Watchtower Demo Broker',
                    logo_url: 'https: //s3-us-west-2.amazonaws.com/watchtower-public/broker_logos/watchtower.png',
                  },
                },
                is_new: false,
              },
              {
                id: 123,
                commentable_id: 2749,
                commentable_type: 'Document',
                content: 'test',
                parent_id: '119',
                user_id: 107,
                created_at: '2018-03-26T21: 12: 53.267896',
                updated_at: '2018-03-26T21: 12: 53.267896',
                user: {
                  id: 107,
                  email: 'guardian@watchtowerbenefits.com',
                  first_name: 'Guardian ',
                  last_name: 'User',
                  carrier: {
                    id: 9,
                    name: 'Guardian',
                    logo_url: 'https: //s3-us-west-2.amazonaws.com/watchtower-public/carrier_logos/guardian.jpg',
                  },
                  broker: {},
                },
                is_new: false,
              },
              {
                id: 125,
                commentable_id: 2749,
                commentable_type: 'Document',
                content: 'test',
                parent_id: '119',
                user_id: 150,
                created_at: '2018-03-26T21: 15: 13.582766',
                updated_at: '2018-03-26T21: 15: 13.582766',
                user: {
                  id: 150,
                  email: 'broker@watchtowerbenefits.com',
                  first_name: 'Watch',
                  last_name: 'Tower',
                  carrier: {},
                  broker: {
                    id: 6,
                    name: 'Watchtower Demo Broker',
                    logo_url: 'https: //s3-us-west-2.amazonaws.com/watchtower-public/broker_logos/watchtower.png',
                  },
                },
                is_new: false,
              },
              {
                id: 127,
                commentable_id: 2749,
                commentable_type: 'Document',
                content: 'test',
                parent_id: '119',
                user_id: 107,
                created_at: '2018-03-26T21: 16: 55.036569',
                updated_at: '2018-03-26T21: 16: 55.036569',
                user: {
                  id: 107,
                  email: 'guardian@watchtowerbenefits.com',
                  first_name: 'Guardian ',
                  last_name: 'User',
                  carrier: {
                    id: 9,
                    name: 'Guardian',
                    logo_url: 'https: //s3-us-west-2.amazonaws.com/watchtower-public/carrier_logos/guardian.jpg',
                  },
                  broker: {},
                },
                is_new: false,
              },
            ],
            user: {
              id: 107,
              email: 'guardian@watchtowerbenefits.com',
              first_name: 'Guardian ',
              last_name: 'User',
              carrier: {
                id: 9,
                name: 'Guardian',
                logo_url: 'https: //s3-us-west-2.amazonaws.com/watchtower-public/carrier_logos/guardian.jpg',
              },
              broker: {},
            },
            is_new: false,
          },
          {
            id: 124,
            commentable_id: 2749,
            commentable_type: 'Document',
            content: 'test',
            parent_id: null,
            user_id: 107,
            created_at: '2018-03-26T21: 15: 00.193088',
            updated_at: '2018-03-26T21: 15: 00.193088',
            replies: [],
            user: {
              id: 107,
              email: 'guardian@watchtowerbenefits.com',
              first_name: 'Guardian ',
              last_name: 'User',
              carrier: {
                id: 9,
                name: 'Guardian',
                logo_url: 'https: //s3-us-west-2.amazonaws.com/watchtower-public/carrier_logos/guardian.jpg',
              },
              broker: {},
            },
            is_new: false,
          },
          {
            id: 126,
            commentable_id: 2749,
            commentable_type: 'Document',
            content: 'test',
            parent_id: null,
            user_id: 107,
            created_at: '2018-03-26T21: 16: 44.809758',
            updated_at: '2018-03-26T21: 16: 44.809758',
            replies: [],
            user: {
              id: 107,
              email: 'guardian@watchtowerbenefits.com',
              first_name: 'Guardian ',
              last_name: 'User',
              carrier: {
                id: 9,
                name: 'Guardian',
                logo_url: 'https: //s3-us-west-2.amazonaws.com/watchtower-public/carrier_logos/guardian.jpg',
              },
              broker: {},
            },
            is_new: false,
          },
          {
            id: 128,
            commentable_id: 2749,
            commentable_type: 'Document',
            content: 'testest',
            parent_id: null,
            user_id: 150,
            created_at: '2018-03-26T21: 17: 08.283382',
            updated_at: '2018-03-26T21: 17: 08.283382',
            replies: [
              {
                id: 129,
                commentable_id: 2749,
                commentable_type: 'Document',
                content: 'test',
                parent_id: '128',
                user_id: 150,
                created_at: '2018-03-26T21: 17: 17.246196',
                updated_at: '2018-03-26T21: 17: 17.246196',
                user: {
                  id: 150,
                  email: 'broker@watchtowerbenefits.com',
                  first_name: 'Watch',
                  last_name: 'Tower',
                  carrier: {},
                  broker: {
                    id: 6,
                    name: 'Watchtower Demo Broker',
                    logo_url: 'https: //s3-us-west-2.amazonaws.com/watchtower-public/broker_logos/watchtower.png',
                  },
                },
                is_new: true,
              },
            ],
            user: {
              id: 150,
              email: 'broker@watchtowerbenefits.com',
              first_name: 'Watch',
              last_name: 'Tower',
              carrier: {},
              broker: {
                id: 6,
                name: 'Watchtower Demo Broker',
                logo_url: 'https: //s3-us-west-2.amazonaws.com/watchtower-public/broker_logos/watchtower.png',
              },
            },
            is_new: true,
          },
        ],
      };
      mock
        .onPost(`${v1}/carrier_portal/comments`)
        .reply(200, replyComment);
      mock
        .onPost(`${v1}/broker_portal/comments`)
        .reply(200, replyComment);
      // this needs to be updated with a namespaced one at some point
      mock
        .onPost(`${v1}/notifications/mark_all_comments_as_read`)
        .reply(200, {});
      mock
        .onGet(`${v1}/carrier_portal/comments/document/1508`)
        .reply(200, carrierComments);
      mock
        .onGet(`${v1}/broker_portal/comments/project/999`)
        .reply(200, brokerComments);
      mock
        .onGet(`${v1}/notifications/unread_comments/999`)
        .reply(200, { unread_notifications: 0 });
    }

    axios.interceptors.response.use(undefined, (err) => {
      const res = err.response;
      if ((!res || res.status === 401 || res.status === 403) && applicationOptions.inactiveLogout) {
        applicationOptions.inactiveLogout();
      }
      return Promise.reject(err);
    });
  },
};
